<div [class.loader-hidden]="!show">
    <div class="loader-overlay">
        <mat-progress-spinner class="example-margin" mode="indeterminate"></mat-progress-spinner>
    </div>
</div>